// third-party
import { createSlice } from '@reduxjs/toolkit';

// project-imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// types
import { chat } from './chat';
import { showSuccessToast } from 'utils/showSuccessToast';
import { ProfilesStateProps } from 'types/profiles';

export const url = process.env.REACT_APP_API_URL + '/api/user/v1/profiles';

const initialState: ProfilesStateProps = {
  profiles: []
};

export const profiles = createSlice({
  name: 'profiles',
  initialState,
  reducers: {
    // SET PROFILES
    setProfiles(state, action) {
      state.profiles = action.payload;
    }
  }
});

export function getProfiles() {
  return async () => {
    try {
      const response = await axios.get(url);
      dispatch(profiles.actions.setProfiles(response.data));
    } catch (error) {
      dispatch(chat.actions.hasError(error));
    }
  };
}

export function addProfile(name: string, description: string, permissions: string[]) {
  return async () => {
    try {
      await axios.post(url, { name, description, permissions });
      await dispatch(getProfiles());
      showSuccessToast('Perfil criado com sucesso');
    } catch (error) {
      dispatch(chat.actions.hasError(error));
      throw error;
    }
  };
}

export function editProfile(profileId: string, name: string, description: string, permissions: string[]) {
  return async () => {
    try {
      await axios.put(`${url}/${profileId}`, { name, description, permissions });
      await dispatch(getProfiles());
      showSuccessToast('Perfil editado com sucesso');
    } catch (error) {
      dispatch(chat.actions.hasError(error));
      throw error;
    }
  };
}

export function duplicateProfile(profileId: string, name: string) {
  return async () => {
    try {
      await axios.post(`${url}/${profileId}/duplicate`, { name });
      await dispatch(getProfiles());
      showSuccessToast('Perfil duplicado com sucesso');
    } catch (error) {
      dispatch(chat.actions.hasError(error));
      throw error;
    }
  };
}

export function deleteProfile(profileId: string, reassignTo?: string) {
  return async () => {
    try {
      const query = reassignTo ? `?reassignTo=${reassignTo}` : '';
      await axios.delete(`${url}/${profileId}${query}`);
      await dispatch(getProfiles());
      showSuccessToast('Perfil removido com sucesso');
    } catch (error) {
      dispatch(chat.actions.hasError(error));
      throw error;
    }
  };
}

export default profiles.reducer;
